var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgEditCircle = function SvgEditCircle(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 123 123",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.792 61.396c0 31.699-25.697 57.396-57.396 57.396S4 93.095 4 61.396 29.697 4 61.396 4s57.396 25.697 57.396 57.396Z",
    stroke: "currentColor",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.644 46.791 3.922-3.891c.927-.927 1.405-1.913 1.433-2.96.028-1.048-.404-2.016-1.294-2.905l-1.724-1.752c-.89-.908-1.868-1.334-2.935-1.278-1.066.055-2.063.537-2.99 1.445l-3.894 3.864 7.482 7.477ZM36.525 88.876l8.095-3.03L80 50.433l-7.482-7.478-35.38 35.414-3.005 8.061c-.278.778-.12 1.445.473 2.001.593.556 1.233.705 1.92.445Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgEditCircle);
export default ForwardRef;